import { useState } from "react";
import {
  UnicoCheckBuilder,
  UnicoThemeBuilder,
  SDKEnvironmentTypes,
  UnicoConfig,
  CallbackCamera,
  SelfieCameraType,
  DocumentCameraType,
} from "unico-webframe";

const useUnicoCamera = () => {
  const [loading, setLoading] = useState(false);

  const urlPathModels = `${process.env.PUBLIC_URL}/models`;

  const config = new UnicoConfig()
    .setHostname(process.env.REACT_APP_HOSTNAME || '')
    .setMobileSdkAppId(process.env.REACT_APP_MOBILE_SDK_APP_API || '')
    .setProjectId(process.env.REACT_APP_PROJECT_ID || '')
    .setProjectNumber(process.env.REACT_APP_PROJECT_NUMBER || '')
    .setHostInfo(process.env.REACT_APP_HOST_INFO || '')
    .setHostKey(process.env.REACT_APP_HOST_KEY || '');

  const unicoTheme = new UnicoThemeBuilder()
    .setColorSilhouetteSuccess("#69c62f")
    .setColorSilhouetteError("#D50000")
    .setColorSilhouetteNeutral("#fcfcfc")
    .setBackgroundColor("#e9e9e9")
    .setColorText("#1362ca")
    .setBackgroundColorComponents("#325ad4")
    .setColorTextComponents("#dff1f5")
    .setBackgroundColorButtons("#406ee2")
    .setColorTextButtons("#dff1f5")
    .setBackgroundColorBoxMessage("#fff")
    .setColorTextBoxMessage("#366fd8")
    .build();

  const unicoCamera = new UnicoCheckBuilder()
    .setTheme(unicoTheme)
    .setModelsPath(urlPathModels)
    .setEnvironment(SDKEnvironmentTypes.PROD)
    .setResourceDirectory("/resources")
    .build();

  const prepareSelfieCamera = async (
      jsonPath: string | UnicoConfig,
      cameraType: SelfieCameraType,
      cameraName: string,
      isUnicoCamera: boolean,
      callbacks: CallbackCamera
    ) => {
      setLoading(true);
  
      const { open } = await unicoCamera.prepareSelfieCamera(
        jsonPath,
        cameraType
      );
      setLoading(false);

      open(callbacks)
    }

    const prepareDocumentCamera = async (
        jsonPath: string | UnicoConfig,
        cameraType: DocumentCameraType,
        cameraName: string,
        isUnicoCamera: boolean,
        callbacks: CallbackCamera
      ) => {
        setLoading(true);
    
        const { open } = await unicoCamera.prepareDocumentCamera(
          jsonPath,
          cameraType
        );
        setLoading(false);

        open(callbacks)
      }

  return { prepareSelfieCamera, prepareDocumentCamera, loading, config };
};

export default useUnicoCamera;
